import { Injectable } from '@angular/core';
import { Hex } from 'viem';

@Injectable({
  providedIn: 'root',
})
export class DevService {
  private readonly devAddresses: Set<string> = new Set([
    '0x88969939faf18a26469aba6636ee6d88f8fe826a',
    '0x5400162b72237a51ec3411d278e6b6b3319bab01'
  ]);

  isDev(address: Hex | string | undefined): boolean {
    if (!address) return false;
    return this.devAddresses.has(address.toLowerCase());
  }
}
